import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Content from './Content';

const styles = () => ({
  root: {},
  fields: {},
});

const NoDataTemplate = ({
  className,
  classes,
}) => {
  return (
    <Content className={classNames(className, classes.root)} />
  );
};

NoDataTemplate.defaultProps = {
  className: '',
};

NoDataTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NoDataTemplate);
